import axios from 'axios';
import { getKjederegAdminApiUrl } from '../../';

export interface ImportNaceKoderResult {
  inserted: number;
  updated: number;
  skipped: number;
}

const baseUrl = () => getKjederegAdminApiUrl() + '/NaceKode';

const NaceKodeApi = {
  import: async (version: string, file: File): Promise<ImportNaceKoderResult> => {
    const formData = new FormData();
    formData.append('version', version);
    formData.append('file', file);

    const response = await axios.post<ImportNaceKoderResult>(`${baseUrl()}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default NaceKodeApi;
